import { defineMessages } from 'react-intl'

const scope = 'app.components.BusinessesActions'

export default defineMessages({
  searchableFields: {
    businessName: {
      id: `${scope}.searchableFields.businessName`,
      defaultMessage: 'Business Name',
    },
    resolvers: {
      id: `${scope}.searchableFields.resolvers`,
      defaultMessage: 'Resolvers',
    },
    businessType: {
      id: `${scope}.searchableFields.businessType`,
      defaultMessage: 'Industry',
    },
    businessAddress: {
      id: `${scope}.searchableFields.businessAddress`,
      defaultMessage: 'Address',
    },
    owners: {
      id: `${scope}.searchableFields.Owners`,
      defaultMessage: 'Owners',
    },
    tin: {
      id: `${scope}.searchableFields.tin`,
      defaultMessage: 'TIN',
    },
  },
  columns: {
    businessStructure: {
      id: `${scope}.columns.businessStructure`,
      defaultMessage: 'Business Form',
    },
    untaxedIncome: {
      id: `${scope}.subjects.untaxedIncome`,
      defaultMessage: 'Untaxed Revenue',
    },
    resolvers: {
      id: `${scope}.columns.resolvers`,
      defaultMessage: 'Resolvers',
    },
    dataSources: {
      id: `${scope}.columns.dataSources`,
      defaultMessage: 'Data Sources',
    },
    businessAddress: {
      id: `${scope}.columns.businessAddress`,
      defaultMessage: 'Address',
    },
    tin: {
      id: `${scope}.columns.tin`,
      defaultMessage: 'TIN',
    },
    location: {
      id: `${scope}.columns.location`,
      defaultMessage: 'Locations',
    },
    numberOfEmployees: {
      id: `${scope}.columns.numberOfEmployees`,
      defaultMessage: 'Employees',
    },
    marketingEfforts: {
      id: `${scope}.columns.marketingEfforts`,
      defaultMessage: 'Marketing Spending',
    },
    estimatedIncome: {
      id: `${scope}.columns.estimatedIncome`,
      defaultMessage: 'Estimated',
    },
    reportedIncome: {
      id: `${scope}.columns.reportedIncome`,
      defaultMessage: 'Reported',
    },
    documentedIncome: {
      id: `${scope}.columns.documentedIncome`,
      defaultMessage: 'Documented',
    },
    numberOfVisitors: {
      id: `${scope}.columns.numberOfVisitors`,
      defaultMessage: 'Number of Visitors',
    },
    numberOfReviews: {
      id: `${scope}.columns.numberOfReviews`,
      defaultMessage: 'Number of Reviews',
    },
    reportedStatus: {
      id: `${scope}.columns.reportedStatus`,
      defaultMessage: 'Report Status',
    },
  },
  actions: {
    showMap: {
      id: `${scope}.actions.showMap`,
      defaultMessage: 'Show Map',
    },
  },
})
